import React from "react";
import "./EmailSuggestion.scss";
function getSpellingSuggestion(email) {
    const replacements = [
        { misspelling: /@hotnail\.com$/, suggestion: "@hotmail.com" },
        { misspelling: /@hormail\.com$/, suggestion: "@hotmail.com" },
        { misspelling: /@hotmail\.con$/, suggestion: "@hotmail.com" },
        { misspelling: /@hotmale\.com$/, suggestion: "@hotmail.com" },
        { misspelling: /@hotmai\.com$/, suggestion: "@hotmail.com" },
        { misspelling: /@hotmil\.com$/, suggestion: "@hotmail.com" },
        { misspelling: /@hotmial\.com$/, suggestion: "@hotmail.com" },
        { misspelling: /@hotmail\.co$/, suggestion: "@hotmail.com" },
        { misspelling: /@hotamil\.com$/, suggestion: "@hotmail.com" },
        { misspelling: /@homail\.com$/, suggestion: "@hotmail.com" },
        { misspelling: /@hotail\.com$/, suggestion: "@hotmail.com" },
        { misspelling: /@hotmaim\.com$/, suggestion: "@gmail.com" },
        { misspelling: /@gmail\.cm$/, suggestion: "@gmail.com" },
        { misspelling: /@gmail\.om$/, suggestion: "@gmail.com" },
        { misspelling: /@gmail\.con$/, suggestion: "@gmail.com" },
        { misspelling: /@gmail\.co$/, suggestion: "@gmail.com" },
        { misspelling: /@gnail\.com$/, suggestion: "@gmail.com" },
        { misspelling: /@gmil\.com$/, suggestion: "@gmail.com" },
        { misspelling: /@gmai\.com$/, suggestion: "@gmail.com" },
        { misspelling: /@gmal\.com$/, suggestion: "@gmail.com" },
        { misspelling: /@gmaill\.com$/, suggestion: "@gmail.com" },
        { misspelling: /@hmail\.com$/, suggestion: "@gmail.com" },
        { misspelling: /@gamil\.com$/, suggestion: "@gmail.com" },
        { misspelling: /@gmail\.se$/, suggestion: "@gmail.com" },
        { misspelling: /@outlook\.om$/, suggestion: "@outlook.com" },
        { misspelling: /@outlook\.co$/, suggestion: "@outlook.com" },
        { misspelling: /@outlock\.com$/, suggestion: "@outlook.com" },
        { misspelling: /@protomail\.com$/, suggestion: "@protonmail.com" },
        { misspelling: /@cloud\.com$/, suggestion: "@icloud.com" },
        { misspelling: /@yhaoo\.com$/, suggestion: "@yahoo.com" },
        { misspelling: /@yhaoo\.se$/, suggestion: "@yahoo.se" },
        { misspelling: /@(.+)\.sr$/, suggestion: "@$1.se" },
    ];
    const replacement = replacements.find((replacement) => replacement.misspelling.test(email));
    if (replacement) {
        return email.replace(replacement.misspelling, replacement.suggestion);
    }
    return email;
}
export function isPotentialMisspelling(email) {
    return getSpellingSuggestion(email) !== email;
}
export const EmailSuggestion = ({ email, msg, setEmail, dismiss }) => {
    const spellingSuggestion = getSpellingSuggestion(email);
    if (spellingSuggestion === email) {
        return null;
    }
    const splitMsg = msg.split("{suggestion}");
    return (React.createElement("div", { className: "email-suggestion" },
        React.createElement("div", { className: "warning-message" },
            splitMsg[0],
            React.createElement("button", { className: "message-button-link", type: "button", onClick: () => setEmail(spellingSuggestion) }, spellingSuggestion),
            splitMsg[1]),
        React.createElement("button", { className: "close", type: "button", onClick: dismiss }, "\u2716")));
};
